/**
 * 服务器地址
 * @type {string}
 */

// const SERVER = 'http://localhost:10088'
// const SERVER = 'http://58.246.29.62:10088/'

const SERVER = 'https://test.51ljb.cn'

// const SERVER = 'https://app.51ljb.cn'

// const SERVER = 'https://servse.51ljb.cn'
const VERSION = 'v2/'

export const Api = {

  BASE_URL: SERVER,

  HTTP_URL: SERVER + '/api/' + VERSION,

  // websocket
  API_WEB_SOCKET: SERVER.replace('http', 'ws') + '/api/' + 'websocket',

  // 获取整个渠道配置信息
  API_GET_CHANNEL: 'channel/getChannel',
  // 获取渠道活动
  API_GET_ACTIVITY: 'h5/getActivity',
  // 发送验证码
  API_SEND_CODE: 'user/sendCode',
  
  // 登录
  API_LOGIN: 'user/codeLogin',

  // oAuth登录
  API_O_AUTH_LOGIN: 'user/userInfo',
  // openid
  API_WEIXIN_OPENID: 'weixin/openid',
  // openid
  API_WEIXIN_BIND_AUTHORIZE: SERVER + '/api/' + VERSION + 'weixin/bindAuthorize',

  // 获取用户信息
  API_GET_USER_INFO: 'user/userCenter',

  // 更新用户信息
  API_UPDATA_USER_INFO: 'user/update',

  // 文书模板列表
  API_DOC_MODULE: 'doctemplate/list',

  // 导出到邮箱
  API_EXPORT_EMAIL: 'doctemplate/export',

  // 获取二级领域标签
  // API_SUBFIELD_LIST: 'field/getSubset',
  API_SUBFIELD_LIST: 'field/getSubsetByFieldValue',

  // 创建电话订单
  API_CREATE_TEL_ORDER: 'order/createCallOrder',

  // 获取订单分类
  API_ORDER_TYPE: 'order/orderType',

  // 查看订单列表
  API_OEDER_LIST: 'order/list-new',

  // 查看电话订单详情
  API_TEL_DETAIL: 'order/callOrderDetail',

  // 查看文书订单详情
  API_DOC_DETAIL: 'order/docTemplateDetail',

  // 报价列表
  API_QUOTED_LIST: 'order/docTemplateLegalPaperList',

  // 选择文书报价
  API_CHOOSE_QUOTED: 'order/selectDocTemplatePaperService',

  // 确认文书报价
  API_COMFIRM_QUOTED: 'order/finishDocTemplateOrder',

  // 取消文书报价
  API_CANCEL_QUOTED: 'order/cancelDocTemplateOrder',

  // 订单动态
  API_ORDER_DYNAMIC: 'order/dynamic',

  // 产品评价
  API_GET_PRODUCT_RATE: 'order/productOrderRate',

  // 评价订单
  API_ORDER_EVALUATEORDER: 'order/evaluateOrder',

  // 获取优惠券
  API_COUPON_LIST: 'coupon/list',

  // 获取文书订单领域
  API_DOC_PARAMS: 'order/getDocTemplateParams',

  // 取消订单
  API_Cancel_CallOrder: 'order/cancelCallOrder',

  // 文件上传
  API_DOC_UPLOAD: 'oss/breakpointUpload',

  // 创建文书订单
  API_DOC_ORDER: 'order/createDocTemplateOrder',

  // 支付订单
  API_PAY_ORDER: 'pay/createPayOrder',

  // 订单购买
  API_CREATE_ORDER: 'order/createOrder',

  // 产品列表
  API_PRODUCT_LIST: 'product/list',

  // 提交评价
  API_COMMIT_EVAL: 'order/evaluateOrder',

  // 未接通原因调查
  API_UNLINK_REASON: 'tag/getCause',

  // 获取评价标签
  API_EVAL_TAG: 'tag/getAllEvaluate',

  // 获取OPENID
  API_GET_OPENID: 'weixin/getOpenId',

  // 获取OPENID
  REDIRECT_OPENID: SERVER + '/api/' + VERSION + 'weixin/authorize',

  // 查看是否有优惠活动
  API_WHICH_ACTIVE: 'activity/whichActivity',

  // 领取优惠券
  API_GET_COUPPON: 'activity/get',

  // 见面咨询下单
  API_FACE_ORDER: 'order/lawyerFaceOrder',

  // 发律师函
  API_LETTER_ORODER: 'order/lawLetterOrder',
  // 代打官司
  API_LAWSUIT: 'order/lawsuitOrder',

  // 发律师函
  API_LETTER_ORDER: 'order/lawLetterOrder',

  // 律师起草
  API_DRAFT_ORDER: 'order/createPaperDraftOrder',

  // 律师起草详情
  API_DRAFT_DDETAIL: 'order/paperDraftOrder',

  // 获取产品价格
  API_PRODUCE_PRICE: 'order/calculatePayAmount',

  // 取消订单
  API_CANCEL_ORDER: 'order/cancelOrder',

  // 微信分享
  API_WX_SHARE: 'weixin/getJSConfig',

  // 检测三要素
  API_GET_USER_CHECK_THREE_ELEMENTS: 'user/checkThreeElements',

  // 保存三要素
  API_GET_USER_SAVE_THREE_ELEMENTS: 'user/saveThreeElements',
  API_CODE_FOR_CHANGE_MOBILE: 'user/codeForChangeMobile',
  API_CHANGE_MOBILE: 'user/changeMobile',
  API_RECOMMEND_PRODUCTS: 'channel/getChnRecommendProducts',
  API_PRODUCTS: 'channel/pageChnProduct',
  API_PRODUCT_DETAIL: 'channel/getChnProduct',
  API_PRODUCT_PRICE: 'order/reconfirmProductPrice',
  API_ORDER_CONTINUE_CONSULT_ORDER: 'order/continueConsultOrder',

  // 商城配置
  API_SHOP_LIST: 'sys/shop/list',
}

export default Api



// WEBPACK FOOTER //
// ./src/libs/request/api.js